import React, { Component } from 'react';
import { Container, Row, Col, FormGroup, Button, Input, Alert } from 'reactstrap';
import { StyleSheet, css } from 'aphrodite';
import MubitDelivery from '../../../assets/images/mubit_delivery.webp'
import MubitDeliveryPNG from '../../../assets/images/mubit_delivery.png'
import { FaArrowRight } from '@react-icons/all-files/fa/FaArrowRight'
import { Link } from 'react-router-dom'
import Routes from '../../../routes'
import { isIOS, isSafari } from 'mobile-device-detect';
import Fork from '../../../utils/Fork'
import API from '../../../api';
const api = new API();
const styles = StyleSheet.create({
    hero: {
        backgroundColor: '#d4e8f5',
        color: '#fff'
    },
    title: {
        color: '#193f83',
        fontWeight: 900
    },
    textGray: {
        color: '#667078'
    },
    textBlack: {
        color: '#000',
        fontWeight: '700'
    },
    cta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '10px 30px',
        fontWeight: '700',
        fontSize: '20px',

    },
    subcta: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '5px 15px',
        fontWeight: '700',
        fontSize: '18px',
        border: 'none',
        borderRadius: 0
    },
    image: {
        boxShadow: '20px -13px #78C0E0'

    },
    flexy: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'baseline',
        paddingBottom: 40
    },
    ctaDiv: {
        display: 'flex',
        height: '100%',
        alignItems: 'center',
        marginTop: '10px'
    },
    highlight: {
        backgroundColor: '#78bfe0',
        fontWeight: 300,
        padding: '2px'
    },
    bold: {
        fontWeight: '900'
    },
    whats: {
        outline: '1px solid #06a77d',
        backgroundColor: '#06a77d',
        color: 'white',
        padding: '8px 30px',
        // margin: '5px 10px',
        fontWeight: '700',
        cursor: 'pointer',
        width: '100%',
        borderRadius: '0',
        border: 'none'
    },

});


class HeroForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            nombre: '',
            email: '',
            telefono: '',
            almacenar: '',
            isSended: false
        }
    }

    sendToCotizador = () => {
        return `/${this.props.online_to}`
    }

    handleInput = ({ target: { value, name } }) => {
        //console.log(name,value)
        this.setState({

            [name]: value

        });

    }

    cotizarConAsesor = () => {
        const { nombre, email, telefono, almacenar } = this.state;
        console.log('SEND', nombre)
        console.log('SEND', email)
        console.log('SEND', telefono)
        console.log('SEND', almacenar)

        window.mixpanel.track('Landings', {
            'site': this.props.site,
            'variation': this.props.variation,
            'convertion_method': 'form_submit',
            'convertion_value': 'form_submit'
        })

        api.contacto.sendContact({
            name: nombre,
            email: email,
            celular: telefono,
            message: almacenar
        }).then(() => {
            this.setState({ isSended: true })
        })

    }

    openWhatsapp = () => {
        window.fbq('track', 'Whatsapp');

        window.open("https://wa.me/5213320192861?text=Hola, me gustaría conocer más de su servicio de bodega", '_blank');
    }

    onSubmitConvertion = (redirectoTo, convertionMethod) => {
        this.props.setLoading(true)
        var tracked = window.mixpanel.track('Landings', {
            'site': this.props.site,
            'variation': this.props.variation,
            'convertion_method': convertionMethod,
            'convertion_value': redirectoTo
        })
        console.log('TRACKED', tracked)
        window.location.href = redirectoTo;

    }

    render() {
        return (
            <div className={css(styles.hero)} >
                <Container fluid={false} >
                    <Row className="py-5">
                        <Col xs={12} md={6} className={css(styles.flexy)} >
                            <h1 className={css(styles.title)}>Tu bodega con la más alta tecnología y comodidad.</h1>
                            <p className={css(styles.textBlack) + " lead mb-1"}>
                                ¡Guarda todo lo que quieras, sin mover un dedo!
                            </p>
                            <p className={css(styles.textGray) + " lead"}>
                                Nuestros especialistas irán hasta la puerta de tu hogar para proteger y almacenar todo lo que quieras guardar, inventariando con fotos todas tus cosas.
                            </p>
                            <div className={css(styles.ctaDiv)}>
                                <Button onClick={() => {
                                    this.onSubmitConvertion(this.sendToCotizador(), 'online')
                                }} className={css(styles.cta) + ""}>Contratar en línea <FaArrowRight /></Button>
                            </div>
                            <div className={css(styles.ctaDiv)}>
                                <Button onClick={() => {
                                    this.onSubmitConvertion(Routes.CotizaAsesor.url, 'asesor')
                                }} className={css(styles.subcta) + ""}>Cotizar con asesor</Button>
                            </div>
                        </Col>
                        {!this.state.isSended && <>
                            <Col xs={12} md={6} className={css(styles.flexy)}>
                                <FormGroup className='w-75'>
                                    <Input type="text" onChange={this.handleInput} value={this.state.nombre} name="nombre" id="exampleEmail" placeholder="Nombre" />
                                </FormGroup>
                                <FormGroup className='w-75'>
                                    <Input type="email" onChange={this.handleInput} value={this.state.email} name="email" id="exampleEmail" placeholder="Email" />
                                </FormGroup>
                                <FormGroup className='w-75'>
                                    <Input type="number" onChange={this.handleInput} value={this.state.telefono} name="telefono" id="exampleEmail" placeholder="Teléfono" />
                                </FormGroup>
                                <FormGroup className='w-75'>
                                    <Input type="text" onChange={this.handleInput} value={this.state.almacenar} name="almacenar" id="exampleEmail" placeholder="¿Qué necesitas almacenar?" />
                                </FormGroup>
                                <Button onClick={this.cotizarConAsesor} className={css(styles.subcta) + ""}>Cotizar con asesor</Button>
                            </Col>
                        </>}
                        {this.state.isSended && <>
                            <Col xs={12} md={6} className={css(styles.flexy)}>
                                <Alert color="light">
                                    Tú mensaje ha sido enviado, pronto un asesor Mubit.co se pondrá en contacto contigo.
                                </Alert>
                                <FormGroup>
                                    <Button target="_blank" onClick={this.openWhatsapp} className={css(styles.whats)} >
                                        Hablar con un asesor por Whatsapp en este momento
                                    </Button>
                                </FormGroup>

                            </Col>
                        </>}
                    </Row>
                </Container>
            </div>
        );
    }
}

export default HeroForm;